import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Hero } from './Hero';
import { WhyChooseUs } from './WhyChooseUs';
import { HowItWorks } from './HowItWorks';
import { Vehicles } from './Vehicles';
import { BrandsAndVehicles } from './BrandsAndVehicles';
// import { Newsletter } from './Newsletter';
import { Faq } from './Faq';
import { SEO } from './SEO';
import { ServiceType, getCityFromSlug, getServiceContent, services } from '../routes/seoRoutes';
//import '../utils/testDynamicContent'; // Import for testing in development

export const Home: React.FC = () => {
  const { city: urlCitySlug } = useParams<{ city: string }>();
  const location = useLocation();
  
  // Determine service from URL path - fixed logic
  const determineServiceFromPath = (pathname: string): ServiceType | undefined => {
    // Sort services by path length (longest first) to avoid partial matches
    const sortedServices = Object.entries(services).sort(([,a], [,b]) => b.path.length - a.path.length);
    
    for (const [serviceKey, serviceConfig] of sortedServices) {
      const pattern = `/${serviceConfig.path}-`;
      if (pathname.startsWith(pattern)) {
        return serviceKey as ServiceType;
      }
    }
    return undefined;
  };

  const service = determineServiceFromPath(location.pathname);
  const cityName = urlCitySlug ? getCityFromSlug(urlCitySlug) : undefined;
  
  // Check if this is a service page with invalid city
  if (urlCitySlug && !cityName) {
    console.warn('⚠️ Home: Invalid city slug provided:', urlCitySlug);
  }

  // Get content for SEO
  const isServicePage = service && cityName;
  const pageContent = isServicePage 
    ? getServiceContent(service, cityName)
    : getServiceContent('valuta-la-tua-auto'); // Default for homepage

  return (
    <>
      <SEO
        title={isServicePage ? pageContent.seoTitle : "Valuta Auto - Valuta la tua auto"}
        description={isServicePage ? pageContent.seoDescription : "Valuta la tua auto con il nostro servizio di valutazione professionale. Veloce, affidabile e senza stress."}
        path={location.pathname}
        city={cityName}
        service={isServicePage ? pageContent.title : undefined}
      />
      <section id="hero">
        <Hero />
      </section>
      <section id="servizi">
        <WhyChooseUs />
      </section>
      <section id="come-funziona">
        <HowItWorks />
      </section>
      <section id="veicoli">
        <Vehicles />
      </section>
      <section id="marche">
        <BrandsAndVehicles />
      </section>
      <section id="faq">
        <Faq />
      </section>
    </>
  );
}; 